import { Button, Card, GlobalNotification } from '@abb-procure/common';
import {
  ApplicationNotification,
  GlobalNotificationApiService,
  NotificationApiService,
} from '@abb-procure/data';
import {
  Component,
  DestroyRef,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { interval } from 'rxjs';

@Component({
  selector: 'procure-app-notifications',
  templateUrl: './app-notifications.component.html',
  styleUrl: './app-notifications.component.scss',
  imports: [GlobalNotification, Button, Card],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AppNotifications {
  protected privacyNotification?: ApplicationNotification;
  protected globalNotification?: ApplicationNotification | null = null;

  private readonly notificationApiService = inject(NotificationApiService);

  private readonly globalNotificationApiService = inject(
    GlobalNotificationApiService,
  );

  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.globalNotificationApiService.notificationUpdated$
      .pipe(takeUntilDestroyed())
      .subscribe((response) => {
        if (!response) {
          return;
        }

        this.globalNotification = response;
      });

    this.fetchData();

    // Check notifications every minute.

    interval(60 * 1000)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.fetchData());
  }

  protected async onAccept(): Promise<void> {
    if (!this.privacyNotification) {
      return;
    }

    const response = await this.notificationApiService.confirmNotification(
      this.privacyNotification.notificationId,
    );

    if (!response || !this.privacyNotification) {
      return;
    }

    this.privacyNotification.display = false;
  }

  private async fetchData(): Promise<void> {
    const response =
      await this.notificationApiService.getApplicationNotifications();

    if (!response) {
      return;
    }

    this.privacyNotification = response.privacyNotification;
    this.globalNotification = response.globalNotification;
  }
}
